import { memo, useMemo } from 'react';
// @mui
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from '@/theme/css';
//
import { NavListProps, NavConfigProps, NavSectionProps } from '../types';
import { useNavHorizontalConfig } from '../config';
import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionHorizontal({ data, config, sx, ...other }: NavSectionProps) {
  const navConfig = useNavHorizontalConfig(config);

  const renderGroups = useMemo(
    () =>
      data.map((group, index) => (
        <Group key={group.subheader || index} items={group.items} config={navConfig} />
      )),
    [data, navConfig]
  );

  return (
    <Stack
      direction="row"
      sx={{
        mx: 'auto',
        ...hideScroll.y,
        ...sx,
      }}
      {...other}
    >
      {renderGroups}
    </Stack>
  );
}

export default memo(NavSectionHorizontal);

// ----------------------------------------------------------------------

type GroupProps = {
  items: NavListProps[];
  config: NavConfigProps;
};

function Group({ items, config }: GroupProps) {
  const renderItems = useMemo(
    () =>
      items.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={1}
          hasChild={!!list.children}
          config={config}
        />
      )),
    [items, config]
  );

  return <>{renderItems}</>;
}
